import { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "./assets/scss/themes.scss";
import Router from "./routes";

const App = () => {
  return (
    <Fragment>
      <Router />
      <ToastContainer />
    </Fragment>
  );
};

export default App;
